import { ParsedQueryResultRequiredBy } from "@app/analytics/utils/metricsUtils";

export type ReadAverages = ParsedQueryResultRequiredBy<
  | "engagement"
  | "meetingScore"
  | "sentiment"
  | "participantMeetingScore"
  | "participantSentiment"
  | "participantEngagement"
  | "participantCharisma"
  | "participantBias"
  | "participantLatePercent"
  | "talkTimePercent"
  | "cameraOnPercent"
  | "cameraOffPercent"
  | "avgParticipantLateBy"
  | "participantMissedMeetingsPercent"
  | "microphoneOffPercent"
>;

const READ_AVERAGES: ReadAverages = {
  // session-level
  engagement: { value: 78, formattedValue: "78" },
  meetingScore: { value: 78, formattedValue: "78" },
  sentiment: { value: 78, formattedValue: "78" },

  // participant-level
  avgParticipantLateBy: { value: 82, formattedValue: "1:22" },
  cameraOnPercent: { value: 79, formattedValue: "79%" },
  cameraOffPercent: { value: 21, formattedValue: "21%" },
  microphoneOffPercent: { value: 17, formattedValue: "17%" },
  participantBias: { value: 78, formattedValue: "78" },
  participantCharisma: { value: 78, formattedValue: "78" },
  participantEngagement: { value: 80, formattedValue: "80" },
  participantLatePercent: { value: 15, formattedValue: "15%" },
  participantMeetingScore: { value: 79, formattedValue: "79" },
  participantMissedMeetingsPercent: { value: 17, formattedValue: "17%" },
  participantParticipation: { value: 94, formattedValue: "94%" },
  participantSentiment: { value: 79, formattedValue: "79" },
  talkTimePercent: { value: 37, formattedValue: "37%" },
};

export default READ_AVERAGES;
